// Extraído de InteractiveContextMenu.openEditModal (Fase 1 P1) para teste isolado.
// Parseia o interactiveId no formato
//   ${mainChartId}_${chartSectionId}_${objectType}_${objectIndex}
// e devolve a estrutura mínima do objeto interativo para o modal de edição, ou
// null quando o id não tem as 4 partes esperadas.
export function parseInteractiveIdForEdit(interactiveId) {
  const parts = interactiveId.split("_");
  if (parts.length < 4) return null;

  const chartSectionId = parts[1];
  const objectType = parts[2];
  const objectIndex = parseInt(parts[3], 10);

  return {
    type: objectType,
    chartId: parseInt(chartSectionId, 10),
    index: objectIndex,
    object: { item: interactiveId },
    moreProps: {
      chartConfig: { id: chartSectionId }, // string p/ casar o tipo esperado
    },
  };
}
